(function() {
    var TooltipController = {
        elements : {
            scrollingElement : document.scrollingElement || document.documentElement,
            tooltip : null
        },
        state : {
            triggers : []
        },

        handleMouseLeave : function(currentTrigger) {
            this.elements.tooltip.remove();
            this.elements.tooltip.innerHTML = "";
            currentTrigger.element.removeEventListener('mouseleave', this.handleMouseLeave);
        },

        handleMouseover : function(currentTrigger) {
            var _self = this;
            var _currentTrigger = currentTrigger;
            this.elements.tooltip.innerHTML = "";
            var textNode = document.createTextNode(currentTrigger.copy);
            this.elements.tooltip.appendChild(textNode);
            this.elements.tooltip.style.top = currentTrigger.dimensions.top + "px";
            this.elements.tooltip.style.left = currentTrigger.dimensions.left + "px";
            document.body.appendChild(this.elements.tooltip);
            currentTrigger.element.addEventListener('mouseleave', function() {
                _self.handleMouseLeave(_currentTrigger);
            });
        },

        addEventListeners : function() {
            for ( var i = 0; i < this.state.triggers.length; i++ ) {
                var _self = this;
                var index = i;
                (function() {
                    var currentTrigger = _self.state.triggers[index];

                    currentTrigger.element.addEventListener('mouseover', function() {
                        _self.handleMouseover(currentTrigger);
                    });
                })();
            }
        },
        init : function() {
            var documentRect = document.body.getBoundingClientRect();
            console.log(documentRect);
            var triggers = document.querySelectorAll('[tooltip-trigger]');
            for ( var i = 0; i < triggers.length; i++ ) {
                var triggerElement = triggers[i];
                var triggerClientRect = triggerElement.getBoundingClientRect();
                this.state.triggers.push({
                    element : triggerElement,
                    copy : triggerElement.getAttribute('tooltip-copy'),
                    dimensions : {
                        top : triggerClientRect.top + this.elements.scrollingElement.scrollTop,
                        left : triggerClientRect.left
                    }
                });
            }

            this.elements.tooltip = document.createElement('div');
            this.elements.tooltip.classList.add('tooltip-copy-wrapper');

            this.addEventListeners();
        }
    }

    document.addEventListener('DOMContentLoaded', function() {
        TooltipController.init();
    });
})();